import m from 'mithril';
const Check = { view: ({ attrs }) => m("svg", Object.assign({ "xmlns": "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink", "version": 1.1, "id": "mdi-check", "width": 24, "height": 24, "viewBox": "0 0 24 24" }, attrs), m("path", { "d": "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })) };
export default Check;
